import { h } from 'preact'
import { useState } from 'preact/hooks'

export const Bandeau = ({ analytics, images, URL, alt, closeButton = false, eventId }) => {
   const [isClosed, setisClosed] = useState(document.cookie.search('bandeauClose-' + eventId) !== -1 ? true : false)

   const closeBanner = () => {
      setisClosed(true)
      // Expire same day midnight
      var d = new Date()
      var expireDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59)
      document.cookie = 'bandeauClose-' + eventId + '=1;expires=' + expireDate.toUTCString() + ';'
   }

   return (
      <div data-testid={`bande-${eventId}`} class={`bandeau mb-2 mb-xl-3 ${isClosed ? 'isClosed' : ''} ${closeButton ? 'hasCloseButton' : ''}`}>
         <a
            href={URL}
            class="d-block overflow-hidden"
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-pdb-ta={analytics.pdbTa}
            data-adv-canal={analytics.advCanal}
            data-adv-cappingdata={analytics.advCappingdata}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <picture>
               <source srcset={`${images.img2}?saveas=webp`} media="(max-width: 479px)" />
               {closeButton && <source srcset={`${images.img1}?format=x304&saveas=webp`} media="(max-width: 1199px)" />}
               <img src={`${images.img1}?saveas=webp`} alt={alt} loading="lazy" class="image" />
            </picture>
         </a>
         {closeButton ? (
            <button
               type="button"
               onClick={closeBanner}
               title="Fermer"
               class="closeBandeau"
               data-oevent-category="top_event-fermeture"
               data-oevent-action="fermer"
               data-oevent-label={alt}
               data-oevent-other={`{"track_refZ":"acc-digital_occas_top_event-fermeture"}`}
            >
               &times;
            </button>
         ) : (
            ''
         )}
      </div>
   )
}
